export * from './taiwan-vehicle-registration-issue-date-format-strategy';
export * from './taiwan-vehicle-registration-issue-date-strategy';
